import clsx from 'clsx'

import { BuyerIntentAdClick, normalizeBuyerIntentId } from 'components/BuyerIntent'
import { useAppContext } from 'context/AppContext'
import detachTask from 'helpers/detachTask'
import isPpcClickOutUrl from 'helpers/isPpcClickOutUrl'
import sendConversionMetric from 'services/launchDarkly/sendConversionMetric'

import { performClickout, performBxClickout } from './helpers'

import classes from './ClickoutWrapper.module.scss'

const format2NewLandingUrl = url => {
  let formatted = url.replace('/x/', '/z/')
  const queryIndex = formatted.indexOf('?')
  if (queryIndex > 0 && formatted[queryIndex - 1] !== '/') {
    formatted = formatted.substring(0, queryIndex) + '/' + formatted.substring(queryIndex)
  }

  return formatted
}

const dispatchBuyerIntentClick = event => {
  const isContextMenu = event.type === 'contextmenu'
  const isMiddleClick = event.type === 'mouseup' && event.button === 1

  if (!isContextMenu && !isMiddleClick) {
    return
  }

  event.currentTarget.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  )
}

/** @type {import("./types").default} */
const ClickoutWrapper = ({
  children,
  url,
  isClickout,
  className,
  onClick,
  listingPosition = 0,
  buyerIntentCategoryId,
  buyerIntentProductId,
  buyerIntentSourceLocation,
  buyerIntentTrackAdClick = false,
  ...props
}) => {
  const { experiments, query, route } = useAppContext()
  const normalizedBuyerIntentProductId = normalizeBuyerIntentId(buyerIntentProductId)
  const normalizedBuyerIntentCategoryId = normalizeBuyerIntentId(buyerIntentCategoryId)
  const shouldTrackBuyerIntentAdClick = Boolean(buyerIntentTrackAdClick && isClickout && normalizedBuyerIntentProductId)

  const onClickOut = e => {
    // Avoid processing clicks out of the component
    if (e.button < 0) return

    if (shouldTrackBuyerIntentAdClick) {
      dispatchBuyerIntentClick(e)
    }
    e.preventDefault()

    if (onClick) onClick()

    // Remove this conditional once fully migrated to appRouter
    const transactionId = window.__GDM_EVENTS__?.[props['data-evt-id']]?.transactionId

    if (isPpcClickOutUrl(url)) {
      performBxClickout(url, transactionId)
    } else {
      performClickout(format2NewLandingUrl(url), transactionId, listingPosition)
    }

    const ldUserId = experiments?.ga4?.User_Information_GAExperimentUserId
    const pageCategory = query?.categorySlug
    const pageType = route
    const queryParams = new URLSearchParams({ ldUserId, pageCategory, pageType })
    detachTask(sendConversionMetric, queryParams)
  }

  if (isClickout) {
    const clickout = (
      <span
        onMouseUp={onClickOut}
        onContextMenu={onClickOut}
        role="button"
        className={clsx(classes.root, className)}
        {...props}
      >
        {children}
      </span>
    )

    if (shouldTrackBuyerIntentAdClick) {
      return (
        <BuyerIntentAdClick
          productId={normalizedBuyerIntentProductId}
          categoryId={normalizedBuyerIntentCategoryId}
          sourceLocation={buyerIntentSourceLocation}
        >
          {clickout}
        </BuyerIntentAdClick>
      )
    }

    return clickout
  }
  if (!isClickout && url) {
    return (
      <a href={url} className={clsx(classes.root, className)} onClick={onClick} {...props}>
        {children}
      </a>
    )
  }

  return children
}
export default ClickoutWrapper
